// extracted by mini-css-extract-plugin
module.exports = {"results":"Channel_results__18hGp"};